import { Router } from '@reach/router'
import React from 'react'
import { BaseRouter } from './BaseRouter'

export class StaticRouter extends BaseRouter {
  render () {
    const { children, uri, primary } = this.props
    const { hasError } = this.state

    if (hasError) {
      return this.renderError()
    }

    return <Router style={{ height: '100%', width: '100vw' }} uri={uri || ''} primary={primary === true}>{children}</Router>
  }
}
